// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

var M = M || {};
M.Model = M.Model || {};
M.Model.Base = M.Model.Base || {};

/* has the following attributes:
 *  firstName: string, first name of the logged in user
 *  userId: int, the user id of the logged in user
 *  isDesigner: int, 0 or 1 if the logged in user is a designer
 * if neither of these are set, the user is not logged in
 */
M.Model.Base.LoggedInUser = Backbone.Model.extend({

  defaults: {
    userId: 0
  },

  /**
   * Logic is based upon isLoggedInUser from order_status
   * @returns Boolean
   */
  isSignedIn: function () {
    return this.get('userId') !== 0;
  }

});
